import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { BACKEND_URL } from '../../../Constants';

function StudentCourses() {
    const [courses, setCourses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const studentId = localStorage.getItem('userId'); // Make sure 'userId' is the correct key

    useEffect(() => {
        const fetchStudentCourses = async () => {
            if (!studentId) {
                setError("Student ID is not available. Are you logged in?");
                setLoading(false);
                return;
            }

            setLoading(true);
            setError(null);
            try {
                const response = await axios.get(`${ BACKEND_URL }/api/enrollments/student/${studentId}/courses`);
                setCourses(response.data);
                console.log("Fetched courses with details:", response.data); // Inspect the full data
            } catch (err) {
                console.error('Error fetching student courses:', err);
                setError('Failed to load courses. Check the server and student ID.');
                if (err.response) {
                    console.error("Server responded with:", err.response.data);
                    setError(`Failed to load courses: ${err.response.data.message || err.response.statusText}`);
                }
            } finally {
                setLoading(false);
            }
        };

        fetchStudentCourses();
    }, [studentId]);

    const formatStatus = (status) => {
        if (status === 'approved' || status === 'enrolled') { // Account for both "Approved" and "Enrolled" if applicable
            return 'Enrolled';
        }
        if (status === 'completed') {
            return 'Course Completed';
        }
        return status || 'Not Available';
    };

    if (loading) {
        return <div>Loading courses...</div>;
    }

    if (error) {
        return <div className="alert alert-danger" role="alert">Error: {error}</div>;
    }

    if (!courses || courses.length === 0) {
        return <>
            <div>No courses found for this student.</div>
            <div className='pt-3'><a href='/courses' className='btn btn-primary'>View Courses</a></div>
        </>;
    }

    return (
        <div className="card">
            <div className='card-body'>
            <h5 className='card-title'>My Courses <Link class="btn btn-sm btn-info" to="/courses" data-discover="true">Courses</Link></h5>
            <div className="table-responsive">
               <table className="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Title</th>
                            <th scope="col">View</th>
                            <th scope="col">Status</th>
                            <th scope="col">Quiz Score</th> {/* NEW COLUMN HEADER */}
                        </tr>
                    </thead>
                    <tbody>
                    {courses.map((course, index) => (
                        <tr key={course._id}>
                            <th scope="row">{index + 1}</th>
                            <td>{course.title}</td>
                            <td>
                            <Link to={`/course/${course._id}`} className="btn btn-sm btn-info">
                            View
                            </Link>
                            </td>
                            <td>{formatStatus(course.enrollmentStatus)}</td>
                            <td>{course.quizScore || 'N/A'}</td> {/* NEW COLUMN DATA */}
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            </div>
        </div>
    );
}

export default StudentCourses;